module.exports = "463c85c9482da904dcc4289af6b17c00.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/platform-edge-L.png
// module id = 39
// module chunks = 0